import {ILoanRequestRuleResponse} from '../../../../../services/hookService/getLoanRequestRule/types';
import Num2persian from '../../../../../utilities/helper/convertNumToPersian';
import {convertToPersianDate} from '../../../../../utilities/helper/GetPersianDateTime';
import {PersonPrefix} from '../credit-loan/Forms/MultiPersonForm/MultiPersonValidation';

interface PersonDescriptionProps {
  personType: PersonPrefix;
  rules: ILoanRequestRuleResponse;
}

const PERSON_CONFIG = {
  self: {
    chequeFields: [
      'owner_first_cheque_price',
      'owner_second_cheque_price',
      'owner_third_cheque_price',
    ] as const,

    singleTitle: 'چک به نام خود فرد',

    multiTitle: (count: number) => `${count} عدد چک به نام خود فرد`,

    ownerLabel: 'خودتان',
  },

  'Guarantor-0': {
    chequeFields: ['first_guarantor_cheque_price'] as const,

    singleTitle: 'چک ضامن اول',

    multiTitle: (count: number) => `${count} عدد چک ضامن اول`,

    ownerLabel: 'ضامن اول',
  },

  'Guarantor-1': {
    chequeFields: ['second_guarantor_cheque_price'] as const,

    singleTitle: 'چک ضامن دوم',

    multiTitle: (count: number) => `${count} عدد چک ضامن دوم`,

    ownerLabel: 'ضامن دوم',
  },
};

const formatPrice = (price: number): string => {
  return new Intl.NumberFormat('fa-IR').format(price);
};

const getChequePrices = (
  personType: PersonPrefix,
  rules: ILoanRequestRuleResponse,
): number[] => {
  return PERSON_CONFIG[personType].chequeFields
    .map(field => rules[field])
    .filter(price => Boolean(price));
};

const PersonDescription = ({personType, rules}: PersonDescriptionProps) => {
  const config = PERSON_CONFIG[personType];

  const chequePrices = getChequePrices(personType, rules);

  const chequeCount = chequePrices.length;

  const title =
    chequeCount === 1 ? config.singleTitle : config.multiTitle(chequeCount);

  const pricesText = chequePrices
    .map(price => `${formatPrice(price)} تومان`)
    .join(' و ');

  const chequeText =
    chequeCount === 1 ? 'یک چک صیادی' : `${Num2persian(chequeCount)} چک صیادی`;

  const description = `
${chequeText} ${config.ownerLabel}
را به مبلغ ${pricesText}
در وجه شرکت ${rules?.receiver_name}
به شناسه ملی ${rules?.national_id}
بابت تادیه دیون
به تاریخ ${convertToPersianDate(rules?.cheque_receipt_date)}
ثبت کنید.
`
    .replace(/\s+/g, ' ')
    .trim();

  return (
    <>
      <h3 className="mb-2 text-sm font-medium">{title}</h3>

      <span className=" [word-spacing:4px]">{description}</span>
    </>
  );
};

export default PersonDescription;
